export default __webpack_public_path__ + "static/media/03_Rijnhuizerbrug_1-huidige situatie.bc8861fc.jpg";